export class PipeSizeModel {
    _id: string;
    id: number;
    pipeId: number;
    nominalWidth: string;
    maxSpanWithInsulation: number;
    maxSpanWithoutInsulation: number;
    insulationThicknessDefault: number;
    outerDiameter: number;
    nominalDiameter: number;
    wallThickness: number;
    weightPMeter: number;
    code: string;

    constructor(_id = null,
        id = null,
        pipeId = null,
        nominalWidth = '',
        code = '',
        maxSpanWithInsulation = null,
        maxSpanWithoutInsulation = null,
        insulationThicknessDefault = null,
        outerDiameter = null,
        nominalDiameter = null,
        wallThickness = null,
        weightPMeter = null
    ) {
            this._id = _id;
            this.id = id;
            this.code = code;
            this.pipeId = pipeId;
            this.nominalWidth = nominalWidth;
            this.maxSpanWithInsulation = maxSpanWithInsulation;
            this.maxSpanWithoutInsulation = maxSpanWithoutInsulation;
            this.insulationThicknessDefault = insulationThicknessDefault;
            this.nominalDiameter = nominalDiameter;
            this.outerDiameter = outerDiameter;
            this.wallThickness = wallThickness;
            this.weightPMeter = weightPMeter;
    }
}
